<template>
    <section class="mashup spacer">
        <vue-headful
            title="Qlik Sense Mashups | What are Qlik sense mashups and why do I need them"
            description="Combining the Qlik Sense analytics platform with client site frameworks, such as HTML, CSS, jQuery, Node, React, and others, create beautiful and powerful applications that drive user engagement because it is built with the end user in mind. "
            url='https://www.fedsight.com/Qlik-Sense-Mashups'
        />
        <section class='container-fluid mashupHero d-flex align-items-center justify-content-center'>
        </section>

        <section class='mainParagraph'>
            <div class='container'>
                <h1 class='fedsightGreen mashupHeader'>Qlik Sense Mashups</h1>
                <p style='text-align: center;'><i>What are mashups and why do I need them?</i></p> 
            </div>
        </section>

        <section class='blogPost'>
            <div class='container blogPostContainer'>
                <p style='padding-bottom: 2rem;'>
                    A common misunderstanding among user bases for Qlik Sense is grasping what the concept of a Qlik sense Mashup is and why it may be more suitable than the Qlik Sense native application. You want to use a Qlik Sense Mashup when there is a need for customization no matter the form it takes. The ability to customize code offers a more tailored UX/UI, facilitates dynamic content, and enables additional custom content that a Qlik Sense Application does not allow for in its base features. This article will cover what a Mashup consists of and will explore the concepts of the impacts of effective UX/UI on dynamic content and how it relates to developing a Mashup. 
                </p>

                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    What are Qlik Sense Mashups?
                </h2>
                <p>
                    Combining the Qlik Sense analytics platform with client site frameworks, such as HTML, CSS, jQuery, Node, React, and others, create visually appealing and powerful applications that drive user engagement because it is built with the end user in mind. Qlik Sense Mashups can be a web page, web site or other application. This not only gives you the ability to restructure the application to a format that provides a better UX/UI, but it also gives the ability to have a custom interface with custom design and take advantage of Qlik Senses’ APIs to have functions that perform actions not natively available to Qlik Sense. 
                </p>

                <h2 class='fedsightBlue'>
                    Mashups Allow for Highly Customized UX/UI
                </h2>
                <p>
                    UX, otherwise known as User Experience, is defined by Don Norman,as ‘encompass[ing] all aspects of the end-user’s interaction with the company, its services, and its products.’.
                </p>
                <p>
                    A UX designer prioritizes the overall feel of the experience and gauges the ease for a user to accomplish tasks. For example, standard Qlik Sense navigation is not intuitive to new users and is cumbersome for even experienced users. By adding a simple navigation bar at the top of page in the mashup, users can easily navigate through the application as they do with any other mainstream website. Although the function remains the same,  we can take the design a step further by adding custom colors, custom fonts, and branding to the navbar enhancing the overall feeling that the user experiences when they use the site.  
                </p>
                <p>
                    UI, otherwise known as User Interface, is the way a user interacts with a website, device, machine, etc. the measure of an effective UI is how intuitive it is to the user. An example of this would be a button to the top right of the page with no symbol. The vague button in this example leads the user to question what the intent of the button is; is it for more information, an outside link to a relevant source, etc. If the same button has an ‘x’, ‘-’, or the word ‘close’ inside to indicate that it closes or minimizes the section/page makes it very clear to the user what the intended purpose of the button is.
                </p>
                <p>
                    Take a moment to look at the following two websites for an at-a-glance view of how UX/UI can evoke a response: <a href='https://www.airbnb.com/' target='_blank' rel='noreferrer'>https://www.airbnb.com/</a> and <a href='http://www.pnwx.com/' target='_blank' rel='noreferrer'>http://www.pnwx.com/</a>. As you look at these two sites ask yourself if they answer a few simple questions: 
                </p>
                <ul>
                    <li>What is this company and what do they do?</li>
                    <li>How much do these services cost?</li>
                    <li>Is this company trustworthy?</li>
                    <li>Is the site mobile friendly?</li>
                </ul>
                <p>
                    These are only a few questions that we use to judge a site in less than a matter of seconds. According to recent studies, people make snap judgements on websites to determine if they stay on the site or not, these are usually in less than 50 milliseconds! This statistic alone demonstrates that it has never been more important to create projects that not only have the raw data that is easy to digest, but we also need great design to get people to stay and read the content. 
                </p>
                <p>
                    Together, UX/UI makes websites overall easier to use and can evoke certain feelings dependent upon what the message of the application is being used for. In the case of Qlik Sense, we can accomplish this in mashups by adding in custom functionality, branding, using custom icons, and having event listeners that provide dynamic content all while being mobile friendly!  
                </p>

                <h2 class='fedsightBlue'>
                    Mashups’s Dynamic Content Features
                </h2>
                <p>
                     Through our experience, we have found that the ability to dynamically introduce, hide/show, remove, or alter content are some of the most vital aspects to a websites useability. This not only allows for content to be condensed into a single page application (SPA), but it creates a smoother and richer user experience (UX). Some of the most common examples of this are forms. Think of H&R Block or TurboTax: they use this type of dynamic form to guide you through tax preparation. As you answer questions in the form, certain content is shown, hidden, or navigates the user to additional screens based on entered information. The same principle can be applied to almost anything on a website, thus making the case for mashup development.  
                </p>
                <p>
                     Out-of-the-box Qlik Sense functionality can execute the basics, however, the possibilities are seemingly endless in a Mashups. Fedsight has the expertise to utilize built in Qlik Sense functionality and more to deliver  beautiful and powerful applications or mashups with capabilities that will drive lasting results. 
                </p>
            </div>

            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Who we are
                </h2>
                <p>
                    Fedsight Consulting is an SBA certified HUBZone small business consulting firm focused on helping organizations improve operations and program performance. Our strategic, financial, and operational support services provide insight and perspective on program performance and operational trends. Fedsight Consulting’s subject matter expertise, methods, and tools enable federal organizations to accomplish objectives, effectively manage resources, and improve program performance.
                </p>
                <p>
                    To learn more about how Qlik Sense Mashups could be utilized within your organization, reach out to <span class='emailLink' @click='emailUs()'>info@fedsight.com</span> to schedule a meeting to learn more..
                </p>
            </div>
        </section>

        <Footer />
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../../mixins/closeMenu'


export default {
    name: 'mashups',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/Qlik-Sense-Mashups'}
      ]
    },
    mixins: [closeMenu],
    methods: {
      emailUs(){
          window.location.href = "mailto:info@fedsight.com?subject=I%20would%20like%20to%20learn%20more%20about%20Fedsight&body=Hello,%0D%0A%0D%0APlease%20contact%20me%20to%20discuss%20how%20Fedsight%20can%20assist%20my%20company.%0D%0A%0D%0A";
      }
    },
    mounted() {
      document.dispatchEvent(new Event('page.rendered'));
    }
}
</script>

<style scoped>
.blogPost{
    text-align: left;
}
.blogPostContainer{
    max-width: 100rem;
    margin: 3rem auto;
}
.mashupHero{
    height: 25rem;
    background-image: url('./blogAssets/mashup.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin-top: 10rem;
    max-width: 65rem;
}
.mashupHeader{
    color: #fff;
    font-size: 6rem;
    text-align: center;
}
.mainParagraph{
    padding: 6rem 0rem 2rem;
    max-width: 80rem;
    margin: auto;
    text-align: left;
}
.emailLink{
    color: #007bff;
    cursor: pointer;
}
.emailLink:hover{
    color: #0056b3;
    text-decoration: underline;
}
h2{
    margin-top: 3rem;
}


/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
    .mashupHero{
      justify-content: center !important;
      background-position: left bottom;
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>